<template>
  <div class="booking-card">
    <div class="display-flex">
      <div class="display-flex align-items-center">
        <div class="booking-card-date">
          <span class="dot"></span>
          <!-- <f7-icon material="schedule" color="gray" size="14"></f7-icon> -->
          <!-- <Countdown :date="start"></Countdown> -->
          {{ startDate }}
        </div>
        <div class="booking-card-meta-item">{{ language }} · {{ level }}</div>
      </div>
    </div>
  </div>
</template>

<script>
import { format } from 'date-fns';
import { BASE_PATH } from '@/js/constants/index.js';

// import Countdown from '@/components/Countdown.vue';

export default {
  name: 'BookingCard',

  // components: {
  //   Countdown
  // },

  props: {
    id: {
      type: Number,
      required: true
    },

    languageId: {
      type: Number,
      required: true
    },

    levelId: {
      type: Number,
      required: true
    },

    start: {
      type: String,
      required: true
    }
  },

  data() {
    return {
      date: new Date()
    };
  },

  computed: {
    BASE_PATH: () => BASE_PATH,

    language() {
      return this.$store.state.languages.find(language => language.id === this.languageId).name;
    },

    level() {
      return this.$store.state.levels.find(level => level.id === this.levelId).name;
    },

    startDate() {
      return format(new Date(this.start), 'dd.MM.yyyy H:mm');
    }
  },

  created() {
    const updateCurrentDate = setInterval(() => (this.date = new Date()), 1000);

    this.$once('hook:beforeDestroy', () => {
      clearInterval(updateCurrentDate);
    });
  }
};
</script>

<style lang="scss" scoped>
.booking-card {
  padding: 15px 15px;
  width: 100%;
  background: #ffffff;
  border: 1px solid #d8d8d8;
  border-left: 0;
  border-right: 0;
  box-sizing: border-box;

  --f7-button-min-width: 150px;

  &-date {
    line-height: 1;
    display: flex;
    align-items: center;
    font-size: 14px;
    color: rgba(#5a6169, 0.6);

    /* .icon {
      margin-right: 5px;
    } */

    .dot {
      width: 12px;
      height: 12px;
      margin-right: 5px;
      border-radius: 50%;
      background-color: #ff001f;
    }
  }

  &-meta {
    display: flex;
    align-items: center;
    /* margin-top: 15px; */

    &-item {
      /* margin-top: 5px; */
      margin-left: 10px;
      font-size: 15px;
      color: #000000;
      line-height: 1;

      &:first-child {
        max-width: 120px;
        width: 100%;
      }

      .icon {
        margin-right: 7px;
      }
    }
  }
}
</style>
